const libDialogMoreContacts = {
  namespaced: true,
  state: {
    requests: {
      // restEnterpriseEnterpriseContactsList // 获取联系人信息
    }, // request集合
    companyData: {},
    buryPointFn: null,
    configUrl: {},
  },
  getters: {
    requests: (state) => state.requests,
    companyData: (state) => state.companyData,
    buryPointFn: (state) => state.buryPointFn,
    configUrl: (state) => state.configUrl,
  },
  mutations: {
    updateRequests(state, requests) {
      state.requests = requests;
    },
    updateCompanyData(state, companyData) {
      state.companyData = companyData;
    },
    updateBuryPointFn(state, buryPointFn) {
      state.buryPointFn = buryPointFn;
    },
    updateConfigUrl(state, configUrl) {
      state.configUrl = configUrl;
    },
  },
  actions: {},
};
export default libDialogMoreContacts;
